'use client';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui, monospace', maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{ color: '#B83458' }}>Something went wrong</h2>
      <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#dc2626', background: '#fef2f2', padding: '1rem', borderRadius: '8px', fontSize: '0.875rem' }}>
        {error.message}
      </pre>
      {error.stack && (
        <details style={{ marginTop: '1rem' }}>
          <summary style={{ cursor: 'pointer', color: '#6b7280' }}>Stack trace</summary>
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', color: '#6b7280', background: '#f9fafb', padding: '1rem', borderRadius: '8px', fontSize: '0.75rem', marginTop: '0.5rem' }}>
            {error.stack}
          </pre>
        </details>
      )}
      {error.digest && <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>Digest: {error.digest}</p>}
      <button
        onClick={reset}
        style={{ marginTop: '1rem', padding: '0.5rem 1rem', background: '#B83458', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}
      >
        Try again
      </button>
    </div>
  );
}
